import { formatAmountDateBack } from '../../utils/formatUtils';

export const adapterResponseBoard = (adapterBoard) => {
  const { fecha, fechasCalendario, primeraFecha, ultimaFecha, partesDiarios, partesTotales } =
    adapterBoard;

  return {
    fecha: formatAmountDateBack(fecha),
    fechasCalendario: fechasCalendario.map((fechaCal) => formatAmountDateBack(fechaCal)),
    partesDiarios,
    partesTotales,
    primeraFecha: formatAmountDateBack(primeraFecha),
    ultimaFecha: formatAmountDateBack(ultimaFecha)
  };
};

export const adapterResponseWorkReport = (adapter) => {
  const { fecha, items, pageIndex, totalCount, totalPages } = adapter;

  return {
    fecha: formatAmountDateBack(fecha),
    items,
    pageIndex,
    totalCount,
    totalPages
  };
};
